import { LocationUpdates } from "planning-portal-library/src/lib/core/domain/models/location-update";
import { Mapper } from "../../../../../core/base";
import { Plan } from "../../../../../core/domain";
import { PlanWebEntity } from "./plan-web-entity";
import { DateTime, Duration } from "luxon";
import { LocationUpdateRepositoryMapper } from "../../../locations/location-update-repository/entities/location-update-repository-mapper";
import { LocationUpdateEntity } from "../../../locations/location-update-repository/entities/location-update-entity";
import { LocationGroupWebEntity } from "../../../location-group/location-group-web-repository/entities/location-groups-web-entity";
import { LocationGroupWebRepositoryMapper } from "../../../location-group/location-group-web-repository/entities/location-group-web-repository-mapper";
import { LocationGroup } from "planning-portal-library/src/lib/core/domain/models/location-group";

export class PlanWebRepositoryMapper extends Mapper<PlanWebEntity, Plan> {

  mapFrom(param: PlanWebEntity): Plan {
    const locationUpdateList: LocationUpdates[] = [];
    const locationUpdateMapper = new LocationUpdateRepositoryMapper();
    param.locationUpdates?.forEach((locationUpdate) => {
      const mappedLocationUpdate = locationUpdateMapper.mapFrom(locationUpdate);
      locationUpdateList.push(mappedLocationUpdate);
    });
    return {
      id: param.id,
      name: param.name,
      description: param.description,
      distance: param.distance ? param.distance : undefined,
      duration: param.duration ? Duration.fromMillis(param.duration) : undefined,
      jobsCount: param.jobsCount,
      locationsCount: param.locationsCount,
      planTypeId: param.planTypeId,
      distributionLaneId: param.distributionLaneId,
      distributionLaneName: param.distributionLaneName,
      day : param.day,
      planDays: param.planDays,
      scheduledDays:param.scheduledDays,
      planTypeName: param.planTypeName,
      units: param.units,
      hasJobFilters: param.hasJobFilters,
      isPlanRevised: param.isPlanRevised,
      status: param.status,
      isScheduled: param.isScheduled,
      createdAt: DateTime.fromISO(param.createdAt ?? ""),
      scheduleFromDate : param.scheduleFromDate ? DateTime.fromISO(param.scheduleFromDate!) : undefined,
      scheduleToDate : param.scheduleToDate ? DateTime.fromISO(param.scheduleToDate!): undefined,
      vehiclesCount: param.vehiclesCount,
      unplannedLocationsCount: param.unplannedLocationsCount,
      plannedLocationsCount: param.plannedLocationsCount,
      locationUpdates: locationUpdateList,
      hasLocationUpdates: param.hasLocationUpdates,
      executionTime: param.executionTime,
      bufferHours: param.bufferHours,
      planLocationGroupCount: param.planLocationGroupCount,
      orgUnitId:param.orgUnitId
    };
  }

  mapTo(param: Plan): PlanWebEntity {
    const locationUpdateEntityList: LocationUpdateEntity[] = [];
    const locationUpdateEntityMapper = new LocationUpdateRepositoryMapper();
    param.locationUpdates?.forEach((locationUpdate) => {
      const mappedLocationUpdateEntity = locationUpdateEntityMapper.mapTo(locationUpdate);
      locationUpdateEntityList.push(mappedLocationUpdateEntity);
    });

    return {
      id: param.id!,
      name: param.name,
      description: param.description,
      distance: param.distance,
      duration: param.duration?.toMillis(),
      jobsCount: param.jobsCount,
      locationsCount: param.locationsCount,
      planTypeId: param.planTypeId,
      distributionLaneId: param.distributionLaneId,
      distributionLaneName: param.distributionLaneName,
      day : param.day,
      planTypeName: param.planTypeName,
      units: param.units,
      hasJobFilters: param.hasJobFilters,
      isPlanRevised: param.isPlanRevised,
      status: param.status,
      isScheduled: param.isScheduled,
      createdAt: param.createdAt.toISO(),
      scheduleFromDate : param.scheduleFromDate!.toISO(),
      scheduleToDate : param.scheduleToDate!.toISO(),
      vehiclesCount: param.vehiclesCount,
      unplannedLocationsCount: param.unplannedLocationsCount,
      plannedLocationsCount: param.plannedLocationsCount,
      locationUpdates: locationUpdateEntityList,
      hasLocationUpdates: param.hasLocationUpdates,
      planLocationGroupCount: param.planLocationGroupCount,
    };
  }

}
